import './ViewOrder.style.less'
import {
  Card,
  Col,
  Descriptions,
  Image,
  Popover,
  Row,
  Space,
  Typography,
} from 'antd'
import { useGetOrderCompanySetting, useGetOrderDetail } from '../Order.hook'
import { getUrlParams, hiddenOrderPropertiesFN, IsJsonString } from '@/utils/common'
import { transfromTotalOrder } from './ViewOrder.transform'
import { formatDeliveryDate } from '@/utils/date'
import { EditFilled } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import PBFPermission from '../../components/PBFPermission'
import {
  concat,
  filter,
  find,
  get,
  includes,
  keyBy,
  lowerCase,
  map,
  orderBy,
  size,
  startCase,
  uniqBy,
} from 'lodash'
import moment from 'moment'
import Fade from '@/components/Fade'
import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
import { useQuery } from 'react-query'
import { getAllDefectsGroup } from '../Order.service'
import { DATE_FORMAT } from '@/constant/date'
import { quantity_breakdown_types_obj } from '../../constant/quanity_breakdown'
import { useEffect, useState } from 'react'
import TJXItemBreakdownTable from './components/TJXItemBreakdownTable/TJXItemBreakdownTable'
import { getValueDynamic } from '../Landing/components/OrderTable/OrderTable.transform'
import { getFieldName } from '../EditOrder/EditOrder.helper'
import { IMG_PLACE_HOLDER } from '@/constant/common'


interface Props {
  hideProperties?: any
  hideActions?: any
}

function ViewOrder(props: Props) {
  const hideProperties = props.hideProperties?.[0] ?? {}
  const hideActions = props.hideActions?.[0] ?? {}
  const toHideEditOrder = hiddenOrderPropertiesFN(hideActions, 'update')
  const [breakdownType, setbreakdownType] = useState('')

  const { data, isFetching } = useGetOrderDetail({
    id: getUrlParams('orderKey'),
  })

  useEffect(() => {
    setbreakdownType(data?.product_details?.quantity_breakdown?.value)
  }, [data])

  const { data: defectGroup } = useQuery(['defect_group'], async () => {
    return (await getAllDefectsGroup())?.data?.data
  })

  const { data: orderSetting = {} } = useGetOrderCompanySetting({
    companyId: data?.company?.id,
  })

  const { default_fields = [], sorted_fields = [], field_names } = orderSetting
  const defaultFieldValue = orderBy(default_fields, ['display_order'], ['asc'])

  const navigate = useNavigate()

  const onClickEdit = (tab) => {
    navigate(`/pbf/orders/edit-order/${data?.id}?tab=${tab}`)
  }

  const mapPropertyByGroup = (group: string, subGroup: string) => {
    if (!get(data, group)) return []

    const valueToHide = hideProperties?.value || []
    const orderProperties = orderBy(
      data[`${group}`][`${subGroup}`],
      'display_order',
      'asc'
    )
    const result = filter(
      orderProperties,
      (item) => !includes(valueToHide, item.field)
    )
    return result
  }

  const isCustomItemBreakDown = () => {
    return breakdownType == quantity_breakdown_types_obj.CUSTOM_ITEM
  }

  // CUSTOM MAP OBJECT THAT IT'S NOT FROM PROPERTIES VALUE
  const getOrderProperty = (orderRecord: any, item: any) => {
    const getProps = getValueDynamic(orderRecord, item.data_source)
    const result = {
      ...getProps,
      field: item.field,
      value: getProps.name,
      name: startCase(item.field),
    }
    return result
  }

  const mapPropertyByGroupOrderInfo = (group: string, subGroup: string) => {
    if (!get(data, group)) return []
    const propertyData = data[`${group}`][`${subGroup}`]
    const valueToHide = hideProperties?.value || []
    const keyDefaultValue: any = keyBy(defaultFieldValue, 'field')

    let infoProperties = orderBy(
      propertyData,
      (item) =>
        item.display_order ??
        keyDefaultValue[item.field]?.display_order ?? ['asc']
    )
    let valueNotPropertyValue = []

    // NEED COMPANY SETTING
    if (size(sorted_fields)) {
      // sort special ordering properties by display order number
      const sortFields = orderBy(sorted_fields, 'display_order', 'asc')

      const orderPropsNotPropertyValue = filter(
        sortFields,
        (item) => !includes(item.data_source, 'property_value')
      )
      let valueProperty = []

      if (size(orderPropsNotPropertyValue)) {
        valueProperty = map(orderPropsNotPropertyValue, (item) =>
          getOrderProperty(data, item)
        )
      }

      const tmpFilter = map(sortFields, (item) => {
        return find(
          [...infoProperties, ...valueProperty],
          (o) => o.field == item.field
        )
      })
      infoProperties = uniqBy(concat(tmpFilter, infoProperties), 'field')
    } else {
      const defaultProperties = [
        { field: 'supplier', data_source: 'supplier', display_order: 1 },
        { field: 'factory', data_source: 'factory', display_order: 2 },
      ]
      valueNotPropertyValue = map(defaultProperties, (item) =>
        getOrderProperty(data, item)
      )
    }

    const result = filter(
      [...valueNotPropertyValue, ...infoProperties],
      (item) => !includes(valueToHide, item?.field)
    )

    return result
  }

  if (isFetching) return <LoadingComponent />

  const handleRenderOrderInfoCard = () => {
    const displayEditButton = toHideEditOrder ? (
      <></>
    ) : (
      <PBFPermission roles={['owner', 'editor']}>
        {!isFetching && (
          <a onClick={() => onClickEdit('1')}>
            <EditFilled className="iconEdit" />
          </a>
        )}
      </PBFPermission>
    )

    return (
      <Card className="card">
        <Typography.Title level={4}>
          Order Info
          {displayEditButton}
        </Typography.Title>
        <Row gutter={16}>
          <Col className="gutter-row" span={24}>
            <Descriptions
              labelStyle={{ width: 200 }}
              contentStyle={{ fontWeight: 'bold' }}
              colon={false}
              column={2}
              className="view-order-card-container"
            >
              {mapPropertyByGroupOrderInfo('property_value', 'values').map(
                (value) => {
                  if (!value) return <></>

                  if (
                    value.data_type == 'date' ||
                    value.data_type == 'datetime'
                  ) {
                    return (
                      <Descriptions.Item key={value.field} label={value.name}>
                        {value.value
                          ? moment(value.value).format(DATE_FORMAT.DDMMYY)
                          : '-'}
                      </Descriptions.Item>
                    )
                  }
                  if (value.data_type == 'file') {
                    return (
                      <Descriptions.Item key={value.field} label={value.name}>
                        <Popover
                          content={
                            <div className="popover-url">
                              <ul>
                                {value?.value?.map((item) => {
                                  return (
                                    <li key={item.uid}>
                                      <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        key={item}
                                      >
                                        {item?.name}
                                      </a>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          }
                          title="Files"
                          trigger="hover"
                        >
                          <p className="file-url-name">Files</p>
                        </Popover>
                      </Descriptions.Item>
                    )
                  }

                  if (value.data_type == 'image') {
                    return (
                      <Descriptions.Item key={value.field} label={value.name}>
                        {value?.value?.length > 0 ? (
                          <Image
                            src={
                              value.value[0].url_path ||
                              value.value[0].thumbnail_url_path
                            }
                            alt={value.value[0].name}
                            fallback={IMG_PLACE_HOLDER}
                            width={100}
                            height={100}
                            style={{ borderRadius: 8 }}
                          />
                        ) : (
                          '-'
                        )}
                      </Descriptions.Item>
                    )
                  }
                  if (value.field === 'deliveryDate') {
                    return (
                      <Descriptions.Item key={value.field} label={value.name}>
                        {formatDeliveryDate(value?.value)}
                      </Descriptions.Item>
                    )
                  }
                  if (value.field !== 'poImage') {
                    const displayLabel =
                      getFieldName(field_names, value.field) ?? value.name

                    return (
                      <Descriptions.Item key={value.field} label={displayLabel}>
                        {value?.value ? value?.value : '-'}
                      </Descriptions.Item>
                    )
                  }
                }
              )}
            </Descriptions>
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <Fade>
      <Space
        className="view-order "
        direction="vertical"
        size="middle"
        style={{ display: 'flex', gap: 24 }}
      >
        {handleRenderOrderInfoCard()}
        <Card className="card">
          <Typography.Title level={4}>
            Product Info
            {!toHideEditOrder && (
              <PBFPermission roles={['owner', 'editor']}>
                {!isFetching && (
                  <a onClick={() => onClickEdit('2')}>
                    <EditFilled className="iconEdit" />
                  </a>
                )}
              </PBFPermission>
            )}
          </Typography.Title>

          <Descriptions
            labelStyle={{ width: 200 }}
            contentStyle={{ fontWeight: 'bold' }}
            colon={false}
            column={2}
          >
            {mapPropertyByGroup('product_details', 'information').map(
              (value) => (
                <Descriptions.Item key={value.field} label={value.name}>
                  {value?.value ? value?.value : '-'}
                </Descriptions.Item>
              )
            )}
            {!isCustomItemBreakDown() &&
              mapPropertyByGroup('product_details', 'attributes').map(
                (value) => (
                  <Descriptions.Item key={value.field} label={value.name}>
                    {value?.value?.join(',')}
                  </Descriptions.Item>
                )
              )}
            <Descriptions.Item label="Total Order Quantity">
              {transfromTotalOrder(
                data?.product_details?.order_quantity?.value,
                breakdownType
              )}
              <PBFPermission roles={['owner']}>
                {!isFetching && (
                  <a onClick={() => onClickEdit('2')}>View order quantity</a>
                )}
              </PBFPermission>
            </Descriptions.Item>
          </Descriptions>
          {isCustomItemBreakDown() && (
            <TJXItemBreakdownTable
              item={data?.product_details?.order_quantity?.value}
            />
          )}
        </Card>
        <Card className="card">
          <Typography.Title level={4}>
            Requirements
            {!toHideEditOrder && (
              <PBFPermission roles={['owner', 'editor']}>
                {!isFetching && (
                  <a onClick={() => onClickEdit('3')}>
                    <EditFilled className="iconEdit" />
                  </a>
                )}
              </PBFPermission>
            )}
          </Typography.Title>

          <Descriptions
            labelStyle={{ width: 200 }}
            contentStyle={{ fontWeight: 'bold' }}
            colon={false}
            column={2}
          >
            {mapPropertyByGroup('requirements', 'information').map((value) => {
              if (lowerCase(value.field) == 'aql')
                return (
                  <Descriptions.Item key={value.field} label={value.name}>
                    {value?.value ? value?.value?.name : '-'}
                  </Descriptions.Item>
                )
              if (value.field == 'defect_group') {
                return (
                  <Descriptions.Item key={value.field} label={value.name}>
                    {defectGroup?.find((item) => item.id == value.value)?.name}
                  </Descriptions.Item>
                )
              }
              if (value.data_type == 'file') {
                return (
                  <Descriptions.Item key={value.field} label={value.name}>
                    <Popover
                      content={
                        <div className="popover-url">
                          <ul>
                            {value?.value?.map((item) => {
                              return (
                                <li key={item.uid}>
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={item.url}
                                    key={item}
                                  >
                                    {item.name}
                                  </a>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      }
                      title="Files"
                      trigger="hover"
                    >
                      <p className="file-url-name">Files</p>
                    </Popover>
                  </Descriptions.Item>
                )
              }
              return (
                <Descriptions.Item key={value.field} label={value.name}>
                  {value?.value ? value?.value : '-'}
                </Descriptions.Item>
              )
            })}
            {mapPropertyByGroup('requirements', 'measurement').map((value) => {
              if (value.field !== 'measurementSpec') {
                // Hide measurement_aql row when it has no value
                if (value.field === 'measurement_aql' && !value?.value) return null

                const rawValue =
                  value.field === 'measurement_aql' && IsJsonString(value?.value)
                    ? JSON.parse(value.value)
                    : value?.value
                const displayValue =
                  typeof rawValue === 'object' && rawValue !== null
                    ? rawValue?.name || JSON.stringify(rawValue)
                    : rawValue
                return (
                  <Descriptions.Item key={value.field} label={value.name}>
                    {displayValue}{' '}
                    {value.field !== 'measurement_aql' && (
                      <PBFPermission roles={['owner', 'editor']}>
                        {!isFetching && (
                          <a onClick={() => onClickEdit('3')}>
                            View measurement table
                          </a>
                        )}
                      </PBFPermission>
                    )}
                  </Descriptions.Item>
                )
              }
            })}

            {mapPropertyByGroup('requirements', 'product_weight').map(
              (value) => {
                if (value.field !== 'productWeightSpec') {
                  return (
                    <Descriptions.Item key={value.field} label={value.name}>
                      {value.value}{' '}
                      <PBFPermission roles={['owner']}>
                        {!isFetching && (
                          <a onClick={() => onClickEdit('3')}>
                            View product weight table
                          </a>
                        )}
                      </PBFPermission>
                    </Descriptions.Item>
                  )
                }
              }
            )}
          </Descriptions>
        </Card>
      </Space>
    </Fade>
  )
}

export default ViewOrder
